import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../redux/UserActions";
import { Dialog, Transition } from "@headlessui/react";
import MultiSelectListBox from "./Helper/MultiSelectListBox";
import TimezoneSelect from "react-timezone-select";
import { XIcon } from "@heroicons/react/solid";
import { weekDays } from "../redux/constants";

export default function MoodReminders() {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [notifications, setNotifications] = useState([]);

  function removeReminder(reminder) {
    dispatch(UserActions.removeReminder({ reminder: reminder }));
    dispatch(UserActions.getReminders({}));
  }

  useEffect(() => {
    setNotifications([...userSelector.reminders].reverse());
  }, [userSelector.reminders]);

  useEffect(() => {
    dispatch(UserActions.organization({}));
    dispatch(UserActions.getReminders({}));
  }, []);

  return (
    <>
      <div className="flex flex-col gap-y-4 p-4 w-full bg-gray-100">
        <input
          className="text-lg font-semibold p-2 bg-green-300 rounded-md"
          type="button"
          value="Create Reminder"
          onClick={() => setIsCreateModalOpen(true)}
        />
        {notifications.map((notification) => (
          <div className="grid lg:grid-cols-5 grid-cols-1 gap-y-4 bg-white py-2 px-4 rounded-md">
            <span className="flex flex-col">
              <label className="text-xs font-light">Departments:</label>
              <label className="px-2 font-semibold ">
                {notification.departments.length === 0
                  ? "All"
                  : notification.departments.join(", ")}
              </label>
            </span>
            <span className="flex flex-col">
              <label className="text-xs font-light">Locations:</label>
              <label className="px-2 font-semibold ">
                {notification.locations.length === 0
                  ? "All"
                  : notification.locations.join(", ")}
              </label>
            </span>
            <span className="flex flex-col">
              <label className="text-xs font-light">Time:</label>
              <label className="px-2 font-semibold ">{notification.time}</label>
            </span>
            <span className="flex flex-col">
              <label className="text-xs font-light">Days:</label>
              <label className="px-2 font-semibold ">
                {notification.days.join(", ")}
              </label>
            </span>
            <XIcon
              className="w-full h-8 text-red-600 hover:text-red-900"
              onClick={() => removeReminder(notification._id.$oid)}
            />
          </div>
        ))}
      </div>
      <CreateNotificationCard
        isOpen={isCreateModalOpen}
        setIsOpen={(e) => setIsCreateModalOpen(e)}
      />
    </>
  );
}

function CreateNotificationCard(props) {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [body, setBody] = useState("");
  const [departments, setDepartments] = useState([]);
  const [locations, setLocations] = useState([]);
  const [days, setDays] = useState([]);
  const [time, setTime] = useState("");
  const [timezone, setTimezone] = useState("");

  function createCustomNotification() {
    dispatch(
      UserActions.createReminder({
        reminder: JSON.stringify({
          departments,
          locations,
          days,
          time,
          timezone,
        }),
      })
    );
    dispatch(UserActions.getReminders({}));
  }
  return (
    <Transition appear show={props.isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 h-screen w-screen"
        onClose={() => props.setIsOpen(false)}
      >
        <div className="min-h-screen  text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-20"
            leave="ease-in duration-200"
            leaveFrom="opacity-30"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <div className="flex w-screen h-screen items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-3xl h-auto p-6 transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="flex items-center text-lg w-full justify-center text-center font-medium leading-6 text-gray-900"
                >
                  <XIcon
                    className="fixed left-4 h-8 w-8"
                    onClick={() => props.setIsOpen(false)}
                  />
                  Create a Reminder
                </Dialog.Title>
                <div className="flex flex-col gap-y-1 mt-2">
                  <p className="text-sm text-gray-500">
                    Your reminder will be sent out to everyone targeted by the
                    filters combined.
                  </p>
                  <hr className="my-2" />
                  <div className="grid grid-cols-3 gap-y-2 items-center">
                    <label className="w-full text-left">Departments:</label>
                    <MultiSelectListBox
                      listboxClasses="col-span-2 border-gray-200"
                      label={"Test"}
                      options={userSelector.organization.departments}
                      handleSelected={(e) => setDepartments(e)}
                    />
                    <label className="w-full text-left">Locations:</label>
                    <MultiSelectListBox
                      listboxClasses="col-span-2 border-gray-200"
                      label={"Test"}
                      handleSelected={(e) => setLocations(e)}
                      options={userSelector.organization.locations}
                    />
                  </div>
                  <label className="w-full text-left">Reminder Time:</label>
                  <div className="flex">
                    <MultiSelectListBox
                      listboxClasses="border-gray-200"
                      label={"Test"}
                      handleSelected={(e) => setDays(e)}
                      options={weekDays}
                    />
                    <input
                      type="time"
                      className="rounded border-gray-300 w-full"
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>
                  <TimezoneSelect value={timezone} onChange={setTimezone} />
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2  font-medium text-black bg-green-300 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={() => createCustomNotification()}
                  >
                    Create Notification!
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
